module.exports = __webpack_public_path__ + "static/img/EcoStruxure_Machine_Advisor_PC_Screen.5e041a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/EcoStruxure_Machine_Advisor_PC_Screen.jpg
// module id = 5e3X
// module chunks = 0